import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vidushi',
  templateUrl: './vidushi.component.html',
  styleUrls: ['./vidushi.component.scss']
})
export class VidushiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
